import React from "react";
import { Button, Space, Dropdown } from "@douyinfe/semi-ui";
import type { EditorView } from "@codemirror/view";
import { SNIPPETS, type SnippetGroup } from "./manualSnippets";

interface Props {
  editorRef: React.MutableRefObject<EditorView | null>;
}

const GROUP_ORDER: SnippetGroup[] = ["basic", "block", "layout", "util"];

export function SnippetToolbar({ editorRef }: Props) {
  const ensureView = (): EditorView | null => {
    if (!editorRef.current) return null;
    editorRef.current.focus();
    return editorRef.current;
  };

  const groups = GROUP_ORDER.map((g) => SNIPPETS.filter((s) => s.group === g));

  return (
    <Space spacing={6} wrap>
      {groups.map((items, gi) => (
        <React.Fragment key={gi}>
          {gi > 0 && <span style={{ color: "#ddd", fontSize: 16 }}>│</span>}
          {items.map((s) =>
            s.dropdown ? (
              <Dropdown
                key={s.key}
                trigger="click"
                clickToHide
                render={
                  <div
                    style={{
                      background: "white",
                      padding: 4,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      borderRadius: 4,
                      cursor: "default",
                    }}
                  >
                    {s.dropdown.map((item) => (
                      <div
                        key={item.label}
                        style={{ padding: "6px 16px", cursor: "pointer", borderRadius: 4 }}
                        onClick={() => {
                          const v = ensureView();
                          if (v) item.insert(v);
                        }}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                }
              >
                <Button size="small" theme="borderless">
                  {s.label} ▾
                </Button>
              </Dropdown>
            ) : (
              <Button
                key={s.key}
                size="small"
                theme="borderless"
                onClick={() => {
                  const v = ensureView();
                  if (v) s.insert?.(v);
                }}
              >
                {s.label}
              </Button>
            )
          )}
        </React.Fragment>
      ))}
    </Space>
  );
}
